export abstract class WebComponentEvent extends Event {
  onDisconnect?: () => void;
  constructor(eventName:string) {
    super(eventName, {
      bubbles: true,
      composed: true,
      cancelable: false,
    });
  }
}